
import React from 'react';
import EnhancedDashboardLayout from '@/components/dashboard/EnhancedDashboardLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ProfileInfoTab from '@/components/profile/ProfileInfoTab';
import SecurityTab from '@/components/profile/SecurityTab';
import SubscriptionTab from '@/components/profile/SubscriptionTab';

const Profile = () => {
  return (
    <EnhancedDashboardLayout>
      <div className="px-4 py-6 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-darkgray mb-8">Min profil</h1>

        <Tabs defaultValue="profile" className="space-y-6">
          <TabsList>
            <TabsTrigger value="profile">Profilinformation</TabsTrigger>
            <TabsTrigger value="security">Säkerhet</TabsTrigger>
            <TabsTrigger value="subscription">Abonnemang</TabsTrigger>
          </TabsList>
          
          <TabsContent value="profile">
            <ProfileInfoTab />
          </TabsContent>
          
          <TabsContent value="security">
            <SecurityTab />
          </TabsContent>
          
          <TabsContent value="subscription">
            <SubscriptionTab />
          </TabsContent>
        </Tabs>
      </div>
    </EnhancedDashboardLayout>
  );
};

export default Profile;
